module.exports = __webpack_public_path__ + "static/media/preview.42d196f0.svg";